import { React, useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import Select from "react-select";
import { getPepActionsByUserId } from "../../redux/slices/PepSlice";
import { updateDigDay } from "../../redux/slices/DigDaysSlice";

const EditDigDayForm = ({ digDay, closeModal }) => {
  const dispatch = useDispatch();
  const { loading_getPepActionsByUserId, PepActionListByUserId } = useSelector((state) => ({ ...state.pep }));
  const { loading_updateDigDay } = useSelector((state) => ({ ...state.digDays }));

  const [formValue, setFormValue] = useState({
    digDayId: digDay.digDayId,
    date: digDay.date ? digDay.date.substring(0, 10) : "",
    title: digDay.title || "",
    description: digDay.description || "",
    dayPeriod: digDay.dayPeriod ?? 0,
    isAtOffice: digDay.isAtOffice ?? false,
    actionIds: digDay.actionIds || [],
  });

  useEffect(() => {
    dispatch(getPepActionsByUserId(digDay.userId));
  }, [digDay.userId, dispatch]);

  const pepActionOptions = useMemo(() => {
    if (!PepActionListByUserId?.data) return [];
    return PepActionListByUserId.data.map((action) => ({
      value: action.id,
      label: action.title || action.id,
    }));
  }, [PepActionListByUserId]);

  const selectedActionOptions = useMemo(() => {
    return pepActionOptions.filter((opt) => formValue.actionIds.includes(opt.value));
  }, [pepActionOptions, formValue.actionIds]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePepActionsChange = (selectedOptions) => {
    setFormValue((prev) => ({
      ...prev,
      actionIds: selectedOptions ? selectedOptions.map((opt) => opt.value) : [],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(updateDigDay(formValue));
    if (result?.payload?.status === 200) {
      closeModal();
    }
  };

  const handleReset = () => {
    closeModal();
  };

  return (
    <Form onSubmit={handleSubmit} onReset={handleReset}>
      <FormGroup>
        <Label for="date">Date DigDay</Label>
        <Input
          type="date"
          name="date"
          id="date"
          required
          value={formValue.date}
          onChange={handleChange}
        />
      </FormGroup>
      <FormGroup>
        <Label for="title">Titre</Label>
        <Input
          type="text"
          name="title"
          id="title"
          required
          autoComplete="off"
          value={formValue.title}
          onChange={handleChange}
        />
      </FormGroup>
      <FormGroup>
        <Label for="description">Description</Label>
        <Input
          type="textarea"
          name="description"
          id="description"
          autoComplete="off"
          value={formValue.description}
          onChange={handleChange}
          rows={4}
        />
      </FormGroup>
      <FormGroup>
        <Label for="dayPeriod">Durée</Label>
        <Input
          type="select"
          name="dayPeriod"
          id="dayPeriod"
          value={formValue.dayPeriod}
          onChange={handleChange}
        >
          <option value={0}>Journée complète</option>
          <option value={1}>Matin (AM)</option>
          <option value={2}>Après-midi (PM)</option>
        </Input>
      </FormGroup>
      <FormGroup>
        <Label for="isAtOffice">Lieu</Label>
        <Input
          type="select"
          name="isAtOffice"
          id="isAtOffice"
          value={formValue.isAtOffice}
          onChange={handleChange}
        >
          <option value={false}>À distance</option>
          <option value={true}>Au bureau</option>
        </Input>
      </FormGroup>
      <FormGroup>
        <Label>Actions PEP</Label>
        {loading_getPepActionsByUserId ? (
          <div>Chargement des actions PEP...</div>
        ) : (
          <Select
            isMulti
            options={pepActionOptions}
            value={selectedActionOptions}
            onChange={handlePepActionsChange}
            placeholder="Sélectionner des actions PEP..."
            noOptionsMessage={() => "Aucune action PEP disponible"}
          />
        )}
      </FormGroup>
      <Row className="mt-3">
        <Col md={6}>
          <Button color="danger" type="reset" block>
            Annuler
          </Button>
        </Col>
        <Col md={6}>
          <Button color="warning" type="submit" block disabled={loading_updateDigDay}>
            <i className="bx bxs-save me-1"></i>
            Enregistrer
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default EditDigDayForm;
